import { ApplicationState, ApplicationStore } from '@data';
import { PatientProfile } from '@qmd-types/patient';
import { UpcomingVisit } from '@qmd-types/visits';
import { PatientCreditCard } from '@types';
import { DevToolsSlice, IntakeQuizSlice } from 'data/slices';

export type PersistedState =
  | {
      auth: {
        accessToken?: string;
      };
      patient: {
        patientProfile?: PatientProfile;
        upcomingVisits?: UpcomingVisit[];
        creditCards?: PatientCreditCard[];
      };
      reservedVisit?: ApplicationState['reservedVisit'];
      visit?: ApplicationState['visit'];
      visitTypeId?: ApplicationState['visitTypeId'];
      stateCode?: ApplicationState['stateCode'];
      devTools: Pick<
        DevToolsSlice['devTools'],
        'isLocalPatientWeb' | 'patientWebUrl' | 'isDeployedPatientWeb'
      >;
      intakeQuiz: Pick<
        IntakeQuizSlice['intakeQuiz'],
        'sessionId' | 'currentQuestion' | 'history' | 'prefillCodes' | 'completed'
      >;
    }
  | undefined;

export default function partialize(state: ApplicationStore): PersistedState {
  return {
    auth: {
      accessToken: state.auth.accessToken,
    },
    patient: {
      patientProfile: state.patient.patientProfile,
      upcomingVisits: state.patient.upcomingVisits,
    },
    devTools: {
      isLocalPatientWeb: state.devTools.isLocalPatientWeb,
      patientWebUrl: state.devTools.patientWebUrl,
      isDeployedPatientWeb: state.devTools.isDeployedPatientWeb,
    },
    intakeQuiz: {
      sessionId: state.intakeQuiz.sessionId,
      currentQuestion: state.intakeQuiz.currentQuestion,
      history: state.intakeQuiz.history,
      prefillCodes: state.intakeQuiz.prefillCodes,
      completed: state.intakeQuiz.completed,
    },
    reservedVisit: state.reservedVisit,
    visit: state.visit,
    visitTypeId: state.visitTypeId,
    stateCode: state.stateCode,
  };
}
